export default "__VITE_ASSET__DiD0NW3$__"